import React from 'react'
import SmartIceLogo from '../assets/logos/smart-ice-logo.png'
import PolarViewLogo from '../assets/logos/polar-view-logo.png'

export const LOGOS = {
  'SmartIce': <img src={SmartIceLogo} style={{ width: '100%' }} />,
  'PolarView': <img src={PolarViewLogo} style={{ width: '100%' }} />
}



// WEBPACK FOOTER //
// ./src/config/logos.js